import { useEffect, useState } from 'react';
import AnnouncementsSection from '../components/helpdesk/AnnouncementsSection';
import FooterBar from '../components/helpdesk/FooterBar';
import HeaderBar from '../components/helpdesk/HeaderBar';
import SupportSidebar from '../components/helpdesk/SupportSidebar';
import TicketRequestForm from '../components/helpdesk/TicketRequestForm';
import '../styles/helpdesk.scss';

function HelpdeskPage() {
  const [showSkeleton, setShowSkeleton] = useState(true);

  useEffect(() => {
    const timerId = window.setTimeout(() => {
      setShowSkeleton(false);
    }, 900);

    return () => window.clearTimeout(timerId);
  }, []);

  return (
    <div className="helpdesk-page">
      <HeaderBar />
      <main className="helpdesk-main">
        <div className="helpdesk-main__inner">
          <AnnouncementsSection loadingSkeleton={showSkeleton} />
          <section className="content-grid" aria-label="Submit request and resources">
            <TicketRequestForm loading={showSkeleton} />
            <SupportSidebar loadingSkeleton={showSkeleton} />
          </section>
        </div>
      </main>
      <FooterBar />
    </div>
  );
}

export default HelpdeskPage;
